import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=60316c96"
import script from "./UserForm.vue?vue&type=script&lang=ts"
export * from "./UserForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports